export var IGateway = Symbol();
//# sourceMappingURL=IGateway.js.map